import { render } from "./order-status-faq.vue?vue&type=template&id=678898c1&scoped=true"
import script from "./order-status-faq.vue?vue&type=script&lang=js"
export * from "./order-status-faq.vue?vue&type=script&lang=js"

import "./order-status-faq.vue?vue&type=style&index=0&id=678898c1&scoped=true&lang=scss"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678898c1"]])

export default __exports__